export enum GpsOptionsKeys {
  longitude = 'gps.longitude',
  latitude = 'gps.latitude'
}

export enum UserOptionsKeys {
  theme = 'user.theme',
  access = 'user.access'
}
